export default __webpack_public_path__ + "static/trekmedicsinternational-1a440d6cd36d3f5242fb9752c78d68d4.svg";